import { Tracker } from '@deseretbook/events-tracker'

/**
 * Sets up a singleton of the events-tracker to be used to track any GA event
 * throughout the site.
 */
const Analytics = new Tracker()

export default Analytics
